import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isFFReferralSession } from '../common/common';

// The single source for Friends & Family state, read straight from redux.
//
// It used to be re-derived at four call sites with three different expressions - Product.js
// added an `|| sessionResponse.promoCode === 'FRIENDSFAMILY26'` clause the others did not
// have, which is how a session could get the filtered FF catalog rendered at standard
// pricing - and it used to fall back to a sessionStorage record, which a visitor could write
// by hand. Redux is now the only place any of it lives, and the reducer is its only writer.
//
// The root reducer mounts this slice as OrderState. Reading state.order returned undefined on
// every selector, which is why the redemption state machine never gated anything.
export const useFFReferral = () => {
  const isRedeemTokenValid = useSelector((state) => state.OrderState?.isRedeemTokenValid);
  const isFFReferrer = useSelector((state) => state.OrderState?.isFFReferrer);
  const ffReferrerEmail = useSelector((state) => state.OrderState?.ffReferrerEmail);
  const ffSiteToken = useSelector((state) => state.OrderState?.ffSiteToken);
  const ffPromoCode = useSelector((state) => state.OrderState?.ffPromoCode);

  return useMemo(() => {
    const isFFFlow = isFFReferralSession({ isRedeemTokenValid, isFFReferrer });
    // Never hand out the attribution values unless entitlement itself holds, so a half-written
    // state cannot put a referrer or a promo on an order that is not a referral order.
    return {
      isFFFlow,
      ffReferrerEmail: isFFFlow ? (ffReferrerEmail || '') : '',
      ffSiteToken: isFFFlow ? (ffSiteToken || '') : '',
      ffPromoCode: isFFFlow ? (ffPromoCode || '') : '',
    };
  }, [isRedeemTokenValid, isFFReferrer, ffReferrerEmail, ffSiteToken, ffPromoCode]);
};

export const useFFReferralSession = () => useFFReferral().isFFFlow;

export default useFFReferralSession;
